
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const handlePrivacyClick = () => {
    setMenuOpen(false);
    navigate('/privacy');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  const handleHomeClick = () => {
    setMenuOpen(false);
    navigate('/');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  const handleClaimSpotClick = () => {
    setMenuOpen(false);
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('final-cta');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-4 sm:py-5 flex items-center justify-between">
          <button
            onClick={handleHomeClick}
            className="flex items-center gap-4 group cursor-pointer"
          >
            <img
              src="/brand/logo-light.png"
              alt="HushLegal"
              className="h-14 sm:h-16 w-auto transition-transform duration-300 group-hover:scale-105"
            />
            <span className={`text-[26px] sm:text-[32px] font-black tracking-tight transition-all duration-300 ${
              scrolled ? 'text-gray-900 group-hover:text-[#8B4513]' : 'text-white group-hover:text-[#d4af37]'
            }`}>
              HushLegal
            </span>
          </button>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-10">
            <button
              onClick={handleHomeClick}
              className={`text-[15px] transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-600 hover:text-[#8B4513]' : 'text-white/90 hover:text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={handlePrivacyClick}
              className={`text-[15px] transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-600 hover:text-[#8B4513]' : 'text-white/90 hover:text-white'
              }`}
            >
              Privacy
            </button>
            <button
              onClick={handleClaimSpotClick}
              className="bg-[#d4af37] text-black text-[14px] font-bold px-7 py-3 rounded-full shadow-lg hover:shadow-[0_0_20px_rgba(212,175,55,0.5)] hover:translate-y-[-2px] transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Claim Founders Spot
            </button>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="lg:hidden flex flex-col items-center justify-center w-10 h-10 gap-[6px] cursor-pointer relative z-[60]"
            aria-label="Toggle menu"
          >
            <span
              className={`block w-6 h-[2px] rounded-full transition-all duration-300 ${
                scrolled ? 'bg-gray-900' : 'bg-white'
              } ${menuOpen ? 'rotate-45 translate-y-[8px] !bg-gray-900' : ''}`}
            ></span>
            <span
              className={`block w-6 h-[2px] rounded-full transition-all duration-300 ${
                scrolled ? 'bg-gray-900' : 'bg-white'
              } ${menuOpen ? 'opacity-0 scale-0' : ''}`}
            ></span>
            <span
              className={`block w-6 h-[2px] rounded-full transition-all duration-300 ${
                scrolled ? 'bg-gray-900' : 'bg-white'
              } ${menuOpen ? '-rotate-45 -translate-y-[8px] !bg-gray-900' : ''}`}
            ></span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 bg-black/60 backdrop-blur-sm z-[55] transition-opacity duration-300 lg:hidden ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setMenuOpen(false)}
      ></div>

      {/* Mobile Menu Panel */}
      <div
        className={`fixed top-0 right-0 h-full w-[280px] bg-white border-l border-gray-200 z-[56] transition-transform duration-300 ease-out lg:hidden ${
          menuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col pt-24 px-8 gap-2">
          <button
            onClick={handleHomeClick}
            className="text-gray-600 text-[18px] font-medium py-4 text-left hover:text-[#8B4513] transition-colors duration-200 border-b border-gray-200 cursor-pointer"
          >
            Home
          </button>
          <button
            onClick={handlePrivacyClick}
            className="text-gray-600 text-[18px] font-medium py-4 text-left hover:text-[#8B4513] transition-colors duration-200 border-b border-gray-200 cursor-pointer"
          >
            Privacy
          </button>
          <button
            onClick={handleClaimSpotClick}
            className="bg-[#d4af37] text-black text-[16px] font-bold px-7 py-4 rounded-full shadow-lg mt-6 whitespace-nowrap cursor-pointer hover:shadow-[0_0_20px_rgba(212,175,55,0.5)] transition-all duration-200"
          >
            Claim Founders Spot
          </button>
        </div>
      </div>
    </>
  );
}
